(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name broker.controller:BrokerCtrl
   *
   * @description
   *
   */
  angular
    .module('broker')
    .controller('BrokerCtrl', BrokerCtrl);

  BrokerCtrl.$inject = ['DataService', '$log', 'uiGmapGoogleMapApi', '$location', '$scope', '$timeout'];

  function BrokerCtrl(dataService, $log, uiGmapGoogleMapApi, $location, $scope, $timeout) {
    var vm = this;
    vm.ctrlName = 'BrokerCtrl';
    vm.data = dataService.data;
    vm.selectBroker = selectBroker;
    vm.getBrokerList = getBrokerList;
    vm.dataService = dataService;
    vm.updatePostalCodeAnswer = updatePostalCodeAnswer;
    vm.markerClick = markerClick;
    vm.isMapReady = false;
    vm.isFirstTimeTilesLoaded = true;
    vm.getSbuWebsite = dataService.getSbuWebsite;

    vm.map = {
      zoom: 12,
      control: {},
      events: {
        // Workaround for https://github.com/angular-ui/angular-google-maps/issues/1428
        tilesloaded: function () {
          $scope.$apply(function () {
            if (vm.isFirstTimeTilesLoaded) {
              $log.debug('Map tiles loaded for the first time');
              vm.savedBrokers = vm.data.brokerList.brokers;
              vm.data.brokerList.brokers = [];
              $timeout(function () {
                vm.data.brokerList.brokers = vm.savedBrokers;
              }, 100);
              vm.isFirstTimeTilesLoaded = false;
            }
          });
        }
      }
    };
    vm.postalCodePattern = '[ABCEGHJKLMNPRSTVXYabceghjklmnprstvxy]{1}\\d{1}[A-Za-z]{1}\\s{0,1}\\d{1}[A-Za-z]{1}\\d{1}';

    activate();

    function activate() {
      if (angular.isUndefined(vm.data.quoteResponse)) {
        $log.debug('No response to work with, redirect to quote form.');
        $location.path('/quote');
      } else if (angular.isUndefined(vm.data.brokerList)) {
        vm.data.brokerPostalCode = '' + dataService.getPostalCodeQuestion().answer;
        getBrokerList();
      }
    }

    function getBrokerList() {
      vm.data.selectedBroker = undefined;
      dataService.getBrokerList(vm.data.brokerPostalCode);
    }

    function selectBroker(selectedBroker, scrollIntoView) {
      if (angular.isDefined(vm.data.selectedBroker)) {
        vm.data.selectedBroker.show = false;
      }
      $log.debug('Selected broker ' + selectedBroker.id);
      vm.data.selectedBroker = selectedBroker;
      vm.map.control.getGMap().panTo({
        lat: vm.data.selectedBroker.latitude,
        lng: vm.data.selectedBroker.longitude
      });
      vm.data.selectedBroker.show = true;
      if (scrollIntoView) {
        angular.element('#broker_' + vm.data.selectedBroker.id)[0].scrollIntoView();
      }
    }

    function updatePostalCodeAnswer() {
      vm.data.brokerPostalCode = dataService.formatPostalCode(vm.data.brokerPostalCode);
    }

    function markerClick(googleMarker, eventName, clickedBroker) {
      selectBroker(clickedBroker, true);
    }

    uiGmapGoogleMapApi.then(function (maps) {
      $log.debug('Google map api ready: ' + maps);
      vm.isMapReady = true;
    });
  }
}());
